import { render, staticRenderFns } from "./teacherManagement.vue?vue&type=template&id=26f42152&scoped=true"
import script from "./teacherManagement.vue?vue&type=script&lang=js"
export * from "./teacherManagement.vue?vue&type=script&lang=js"
import style0 from "./teacherManagement.vue?vue&type=style&index=0&id=26f42152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f42152",
  null
  
)

export default component.exports